import {SHORT_LINK_HOST} from '#/lib/constants'
import {logger} from '#/logger'

export function useShortenLink() {
  return async (
    inputUrl: string,
    opts?: {ogCard?: string},
  ): Promise<{url: string}> => {
    try {
      const url = new URL(inputUrl)
      const res = await fetch(`${SHORT_LINK_HOST}/link`, {
        method: 'POST',
        body: JSON.stringify({
          path: url.pathname,
          ...(opts?.ogCard ? {ogCard: opts.ogCard} : {}),
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!res.ok) {
        logger.error('Failed to shorten link', {safeMessage: res.status})
        return {url: inputUrl}
      }

      const data = (await res.json().catch(() => null)) as {url?: string} | null
      if (!data || typeof data.url !== 'string') {
        logger.error('Failed to shorten link', {
          safeMessage: 'invalid response',
        })
        return {url: inputUrl}
      }

      return {url: data.url}
    } catch (e) {
      logger.error('Failed to shorten link', {safeMessage: e})
      return {url: inputUrl}
    }
  }
}
